import React from "react";
import Template from "./Template";



function Login() {
  return (
    <Template
      title="Welcome Back"
      description1="Build skills for today, tomorrow, and beyond."
      description2="Education to future-proof your career."
      image={"https://wallpaperaccess.com/full/1900857.jpg"}
      formType="login"
    />
  )
}

export default Login;